import localforage from 'localforage';
import { persistCombineReducers, persistStore } from 'redux-persist';

import { appStartup } from '../actions/AppActions';

const PersistenceConfig = {
  active: true,
  reducerVersion: '1',
  key: '$reducerVersion',

  storeConfig: {
    key: 'kujhy$1',
    storage: localforage,
    blacklist: [],
    transforms: []
  }
};

const storage = localforage;

const isActive = () => PersistenceConfig.active;

const combineReducers = reducersObj => {
  if (isActive()) return persistCombineReducers(PersistenceConfig.storeConfig, reducersObj);
  return combineReducers(reducersObj);
};

const updateReducers = (store, onComplete) => {
  const reducerVersion = PersistenceConfig.reducerVersion;

  const startup = () => {
    store.dispatch(appStartup());
    if (onComplete) onComplete();
  };

  // Check to ensure latest reducer version
  storage
      .getItem(PersistenceConfig.key)
      .then(localVersion => {
        if (localVersion !== reducerVersion) {
          // Purge store
          console.log(`PURGE: from="${localVersion}" to="${reducerVersion}"`);
          persistStore(store, null, startup).purge();
          storage.setItem(PersistenceConfig.key, reducerVersion);
        } else {
          persistStore(store, null, startup);
        }
      })
      .catch(() => {
        persistStore(store, null, startup);
        storage.setItem(PersistenceConfig.key, reducerVersion);
      });
};

export default { storage, isActive, combineReducers, updateReducers };



// WEBPACK FOOTER //
// ./src/store/persistence.js